
webpack.register(
    'modules/shots-and-stats/shots-and-stats',
    function() {
        return import('modules/shots-and-stats/shots-and-stats');
    },
    true
);